import { IApplicationState } from '../../types/redux';

export const selectActualBanksIds = (state: IApplicationState) =>
  new Set(state.actualMortgageData?.banksList.map(item => item.name));
